<template>
<div class="carouselWrapper">
  <!-- <a href="https://go.shopping.friday.tw/event/202011/20201108-best/index.html" target="_blank">
    <img :src="bannerPath" />
  </a> -->
  <transition-group
    tag="div"
    :name="isNext ? 'back':'slider' "
    mode="out-in">
    <div
      class="imgWrapper"
      v-for="(item,i) in banners"
      :key="i"
      v-show="bannerShow == i"
      @touchstart.stop="fingerPoint"
      @touchmove.stop="fingerMove">
      <a :href="item.url"><img :src="item.img" alt=""></a>
    </div>
  </transition-group>

  <div id="arrowArea">
    <span id="prevBtn" @click="prevBanner"></span>
    <span id="nextBtn" @click="nextBanner"></span>
  </div>
  <div id="dotArea">
    <ul>
      <li
        v-for="(item,key) in bannerLen"
        :class="{'active':bannerShow == key}"
        :key="key"></li>
    </ul>
  </div>

</div>
</template>

<script>
export default {
  name: "carousel",
  data() {
    return {
      banners: [],
      bannerLen: 0,
      bannerShow: 0,
      pointX: null,
      pointY: null,
      isNext: false,
    };
  },
  created() {
    // GET Banners
    this.axios.get("https://event.shopping.friday.tw/event/best-banner/bannerimg.json").then(res => {
      // this.axios.get("api/home/banner/mobileweb").then(res => {
      const data = res.data;
      if (data.code === 1 && data.banners.length > 0) {
        this.banners = data.banners;
        this.bannerLen = data.banners.length;
      }

    });
  },
  mounted() {
    setInterval(() => {
      this.nextBanner()
    }, 8000);
  },
  methods: {
    nextBanner() {

      this.bannerShow == this.bannerLen - 1 ? this.bannerShow = 0 : this.bannerShow++;
      this.isNext = true
    },
    prevBanner() {
      this.isNext = false
      this.bannerShow == 0 ? this.bannerShow = this.bannerLen - 1 : this.bannerShow = this.bannerShow - 1;
      this.isNext = false
    },
    fingerPoint(e) {
      this.pointX = e.touches[0].clientX;
      this.pointY = e.touches[0].clientY;
    },
    fingerMove(e) {
      const moveX = e.touches[0].clientX;
      const moveY = e.touches[0].clientY;
      if (!this.pointX || !this.pointY) {
        return;
      }
      const diffX = moveX - this.pointX;
      const diffY = moveY - this.pointY;
      if (Math.abs(diffX) > Math.abs(diffY)) {
        diffX > 0 ? this.nextBanner() : this.prevBanner();
        this.pointX = null
        this.pointY = null

      }
    }
  }
};
</script>

<style lang="scss" scoped>
.carouselWrapper {
  img {
    width: 100%;
    height: auto;
  }

  margin-bottom: 30px;
  position: relative;
  overflow: hidden;

  .imgWrapper {
    overflow: hidden;

  }

  #dotArea {
    ul {
      text-align: center;

      li {
        display: inline-block;
        width: 32px;
        height: 5px;
        margin: 0;
        background-color: #e0e0e0;

        &.active {
          background-color: #f34f59
        }
      }
    }
  }

  #arrowArea {

    span {
      display: inline-block;
      width: 35px;
      height: 80px;
      padding: 0;
      opacity: 0.6;
      background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAPKADAAQAAAABAAAAPAAAAACL3+lcAAAB9ElEQVRoBe3av0rDUBQG8MY0YHAVXKWr79B0ikMQOung3kdQBIe8go/g4Cbq4mCG0j+L7yBCKfgIJQ5t47liQEK6pOee8xXuhRBu6D05v690ObTVcssl4BJwCbgEXAKNExgMBkGapnuNC1QOepU91Lbb7V6s1+s7z/NyuuLJZPKxbYNsyW3bSPU8YS+Lonig50d0P6arX/1Mkz0k+A97T0jfoOjbXQRB8NQEWD0DB67DUtPJcDj8rDbfZA/1G96EnU6n4ya4ujMwYAmsCQACLIWFAEti1cHSWFWwBlYNrIVVAWtixcHaWFEwAlYMjIIVASNhrYPRsFbBiFhrYFSsFTAylh2MjmUF7wKWDRxF0RlNF5//z6CoeMI5qTDNciyWmRZhr0usaYqGbueIWNMbC5iw76ZYuWh/FcfxQblHurOA2+32LX2rbyWMwFGe56+IaLaZVq/X21+tVi+EPS3hFMI4DMMky7JF+Uz7zgY2kF1As4J3Ac0ORkdbASOjrYFR0VbBiGjrYDS0CBgJLQZGQYuCEdDiYG20ClgTrQbWQquCNdDqYGk0BFgSDQOWQkOBJdAsMy3TKNcajUbfvu/3a2ZkKcc74MAGtQF9wgH+/fMmRyHuGrPZbNnpdB5pKHhItZd03czn8y/u97h6LgGXgEsAOoEfxxguwSHeCBAAAAAASUVORK5CYII=") no-repeat #fff;
      background-position: center;
      background-size: contain;
      border-radius: 0 10px 10px 0;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      cursor: pointer;
    }

    #nextBtn {
      right: 0;
      transform: rotateY(180deg) translateY(-50%);
    }
  }
}

.slider-leave-active,
.slider-enter-active,
.back-leave-active,
.back-enter-active {
  transition: all .5s;
}

.back-enter {
  transform: translateX(-100%);
  opacity: 0;
  position: absolute;
  top: 0;
}

.back-leave-to {
  transform: translateX(100%);
  opacity: 0;
  position: absolute;
  top: 0;

}

.slider-enter {
  transform: translateX(100%);
  opacity: 0;
  position: absolute;
  top: 0;
}

.slider-leave-to {
  transform: translateX(-100%);
  opacity: 0;
  position: absolute;
  top: 0;
}

@media (max-width: 768px) {
  .carouselWrapper {
    margin-bottom: 2%;
  }
}
</style>
